import { render, staticRenderFns } from "./contentTwo.vue?vue&type=template&id=67bb78c4&scoped=true"
import script from "./contentTwo.vue?vue&type=script&lang=js"
export * from "./contentTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bb78c4",
  null
  
)

export default component.exports